module.exports = __webpack_public_path__ + "img/LIGHTING 1 PURPLE.18a24cf.svg";